/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import {put, takeLatest } from '@redux-saga/core/effects';
import { updateAuthError, updateAuthSuccess  } from '../actions/auth.action';
import { SET_AUTH } from 'src/types/auth-action.type';

function* onSetAuth(data:any):any {
  try {
    if (data?.payload && data?.payload?.accessToken) {
      yield put(updateAuthSuccess(data?.payload));
    } else {
      console.log("Account Authenticated Empty", data?.payload);
      throw new Error ('Account Authenticated Empty');
    }
  } catch (err) {
    yield put(updateAuthError(data?.payload));
    console.log("Fail Setting Auth", err);
  }
}

export function* watchOnSetAuth() {
  yield takeLatest(SET_AUTH, onSetAuth);
}
